import React, { useState, useEffect } from 'react';
import { getMsalConfig } from './src/services/msal';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { getHost } from './src/utils';
import Loader from './src/components/loader';
import ErrorPage from './src/components/error';

const MsalWrapper = ({ element }) => {
  const [pca, setPca] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // get the global config for msal configuration
        const host = getHost();
        const response = await fetch(`https://radius-${host}.all.health/configurator/api/v1/config?global=true`);
        if (!response.ok) {
          throw new Error(`Failed to fetch configs: ${response.status} ${response.statusText}`);
        }
        const configs = await response.json();
        const configUrl = configs?.[0];
        if (!configUrl) {
          throw new Error('No config URL found in configs');
        }
        const configResponse = await fetch(
          `https://radius-${host}.all.health/configurator/api/v1/config/get?file_name=${configUrl}`
        );
        if (!configResponse.ok) {
          throw new Error(
            `Failed to fetch config data: ${configResponse.status} ${configResponse.statusText}`
          );
        }
        const configData = await configResponse.json();

        const msalConfig = getMsalConfig(configData);
        const msalInstance = new PublicClientApplication(msalConfig);

        await msalInstance.initialize();

        setPca(msalInstance);
      } catch (err) {
        console.error('Failed to initialize application', err);
        setError(err);
      }
    };

    initializeApp();
  }, []);

  if (error) {
    return <ErrorPage />;
  }

  if (!pca) {
    return <div><Loader /></div>;
  }

  return (
    <MsalProvider instance={pca}>
      {element}
    </MsalProvider>
  );
};

export const wrapRootElement = ({ element }) => {
  return <MsalWrapper element={element} />;
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    // Scroll ourselves: Gatsby's restore would override the native anchor jump
    const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target) {
      target.scrollIntoView();
      return false;
    }
    return true;
  }

  const html = document.documentElement;
  const easing = html.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';
  window.scrollTo(0, 0);
  html.style.scrollBehavior = easing;

  return false;
};
